// extracted by mini-css-extract-plugin
module.exports = {"container":"searchResult_container__3cqUW","result":"searchResult_result__2Fpis","words":"searchResult_words__pxpiW"};